import api from '../common/api';

const basePath = '/mediaItems';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(mediaItem) {
    return api.post(basePath, mediaItem);
  },
  get(mediaItemId, params = {}) {
    return api.get(`${basePath}/${mediaItemId}`, { params });
  },
  getImages(folderName) {
    return api.get(`${basePath}/get/images/${folderName}`);
  },
  delete(mediaItemId, params = {}) {
    return api.delete(`${basePath}/${mediaItemId}`, { params });
  },
  bulkDelete(data = []) {
    return api.delete(`${basePath}/bulk/delete`, { data });
  },
  deletePlaylistsAccountBulk(mediaItemIds = []) {
    return api.delete(`${basePath}/playlists/account`, { data: { mediaItemIds } });
  },
  update(mediaItemId, mediaItem) {
    return api.put(`${basePath}/${mediaItemId}`, mediaItem);
  },
  getFilterOptions(params = {}) {
    return api.get(`${basePath}/filters`, { params });
  },
  getAssociatedPlaylists(mediaItemId, params = {}) {
    return api.get(`${basePath}/associated/${mediaItemId}`, { params });
  },
  getMediaItemInfo(mediaItemId, params = {}) {
    return api.get(`${basePath}/info/${mediaItemId}`, { params });
  },
  getAssociatedSeries(seriesId) {
    return api.get(`${basePath}/associatedSeries/${seriesId}`);
  },
  getLicensesVideos(params = {}) {
    return api.get(`${basePath}/licenses`, { params });
  }
};



// WEBPACK FOOTER //
// ./src/services/mediaItemService.js